import { MouseEvent, ReactElement, useCallback, useMemo } from 'react';

import { ButtonElementType } from '@vestico/model';

import { CSSPropertiesFromString } from '../../../model';

export interface EmbedStyleButtonProps {
  content: string | ReactElement;
  type: ButtonElementType;
  onClick: () => void;
  disabled?: boolean;
  customCSS?: string;
}

export const EmbedStyleButton = ({ onClick, type, content, disabled, customCSS }: EmbedStyleButtonProps) => {
  const performClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      e.preventDefault();
      onClick();
    },
    [onClick]
  );

  const cssProperties = useMemo(() => {
    return CSSPropertiesFromString(customCSS);
  }, [customCSS]);

  switch (type) {
    case 'anchor':
      return (
        <a href="#" onClick={performClick} style={cssProperties}>
          {content}
        </a>
      );
    case 'button':
      return (
        <button type="button" onClick={performClick} style={cssProperties} disabled={disabled}>
          {content}
        </button>
      );
  }
  console.error(`Failed to handle type ${type}`);
  return null;
};
